/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LineToNextPoint/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function LineToNextPoint({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Receivables/Content/Transactions/Transaction/LineToNextPoint"
  
}) {
let entryItemIsLastValueData = fromData.useDataValue({ viewPath,
context: 'entry_item',
path: 'isLast',
})
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
  return (<React.Fragment
>
<fromFlow.When is={!entryItemIsLastValueData}>
<div
  data-testid="LineToNextPoint.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-1-1P8e5D': dtColorsNeutral300}}
 className={`views-block ${styles.Horizontal}`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}